export default {
  state: {
    /** UPDATA_VISITOR 更新visitor
     * UPDATA_NOW_VISITOR 更新当前visitor
     * UPDATA_MESSAGE_LIST 更新聊天内容
     * UPDATA_HISTORY_MESSAGE_LIST
     * **/
    platformStatus: '',
    playingRadioId: '',
    askMId: '',
    // 工作台visiter列表排序 TIME COMEIN
    cvsOrder: '',
    // 客服在线状态
    kefuStatus: '',
    platfromCount: 0,
    platfromNowCount: 0,
    platfromHistoryCount: 0,
    // 是否开启自动应答
    kbSwicth: true,
    // 新手引导步骤: -1 不用了 0 展示新手引导 列表页 1 业务问答列表弹框 2 第一步  3 第二步  4 第三步 5 第四步
    step: -1,
    // 我处理的工单数
    handleNum: 0,
    messageTone: false,
    // 待计入会话数
    lineListCount: 0,
    //工作台是否有选中正在设置星级的对话
    currentStar:'',
    isNoPay:false,
    isLoading:false,
    isShowMoney:false,
  },
  mutations: {
    setShowMoney(state,status) {
      state.isShowMoney = status;
    },
    setLoading(state,status) {
      state.isLoading = status;
    },
    setPayStatus(state,status) {
      state.isNoPay = status;
    },
    setCurrentStar(state,status) {
      state.currentStar = status
    },
    changeMessageTone(state, status) {
      state.messageTone = status
    },
    changeHandleNum(state, status) {
      state.handleNum = status
    },
    changelineListCount(state, status) {
      state.lineListCount = status
    },
    changeStep(state, status) {
      state.step = status
    },
    changePlatformStatus (state, status) {
      state.platformStatus = status
    },
    changePlayingRadioId (state, status) {
      state.playingRadioId = status
    },
    changeCvsOrder (state, status) {
      state.cvsOrder = status
    },
    changeKefuStatus (state, status) {
      state.kefuStatus = status
    },
    addPlatfromCount (state) {
      state.platfromCount++
    },
    clearPlatfromCount (state) {
      state.platfromCount = 0
    },

    setPlatfromNowCount (state, count) {
      state.platfromNowCount = count
    },
    clearPlatfromNowCount (state) {
      state.platfromNowCount = 0
    },
    setPlatfromHistoryCount (state, count) {
      state.platfromHistoryCount = count
    },
    clearPlatfromHistoryCount (state) {
      state.platfromHistoryCount = 0
    },
    changeKbSwicth (state, switchType) {
      state.kbSwicth = switchType
    },
  }
}



// WEBPACK FOOTER //
// ./src/status.js